export default __webpack_public_path__ + "static/media/help-two.07654cae.png";